import { on } from 'delegated-events'
import PhotoSwipe from 'photoswipe'
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default'
import 'photoswipe/dist/photoswipe.css'
import 'photoswipe/dist/default-skin/default-skin.css'

const template = `
  <div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="pswp__bg"></div>
    <div class="pswp__scroll-wrap">
      <div class="pswp__container">
        <div class="pswp__item"></div>
        <div class="pswp__item"></div>
        <div class="pswp__item"></div>
      </div>

      <div class="pswp__ui pswp__ui--hidden">
        <div class="pswp__top-bar">
          <div class="pswp__counter"></div>
          <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>
          <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>

          <div class="pswp__preloader">
            <div class="pswp__preloader__icn">
              <div class="pswp__preloader__cut">
                <div class="pswp__preloader__donut"></div>
              </div>
            </div>
          </div>
        </div>

        <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)">
        </button>

        <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)">
        </button>

        <div class="pswp__caption">
          <div class="pswp__caption__center"></div>
        </div>
      </div>
    </div>
  </div>
`
const SELECTORS = Selectors({
  gallery: '[data-gallery]'
})

const props = {
  $galleries: document.querySelectorAll(SELECTORS.gallery),
  $template: null
}

const fn = {
  init: () => {
    document.body.insertAdjacentHTML('beforeend', template)
    props.$template = document.querySelector('.pswp')
    fn.bindEvents()
  },

  bindEvents: () => {
    on('click', SELECTORS.gallery, (e) => {
      const items = JSON.parse(e.target.closest(SELECTORS.gallery).dataset.gallery)

      const opts = {}
      const gallery = new PhotoSwipe(props.$template, PhotoSwipeUI_Default, items, opts)
      gallery.init();
    })
  },
}

export default {
  can: () => props.$galleries.length,
  run: fn.init
}
